import _ from "lodash";
import {fieldPathJoinGetter} from "../../utils/kp3Utils";
import {generateFetchFieldListAction} from "../../../apps/KpModule/actions/api";

export const entity = {
    name: "ControlType",
    fields: [
        {path: "code", unique: true},
        {path: "name"},
        {
            path: "translatedName",
            fieldPath: ["name"],
            $f: function (object, context, callback) {

                const translate = context?.translateName || (w => w)

                return callback(null, object.name && translate(object.name))
            }
        },
        fieldPathJoinGetter({
            path: "codeName",
            fieldPath: ["code", "translatedName"],
            joinString: " - "
        }),
        {path: "maturityControls", type: "MaturityControl", link: "MTM", nullable: true},
        {path: "axes", type: "Axis", link: "MTM", nullable: true},
        {path: "stakeHolders", type: "Stakeholder", link: "MTM", nullable: true},
    ]
}

export const module_ = {
    object: "ControlType",
    tKey: "mTitle_controlType",
    category: {
        path: "referential",
        icon: 'server'
    },
    defaultSortBy: "code",
    defaultSortDirection: "ASC",
    viewMap: {
        dt: [
            "code",
            {path: "name", translateName: true},
        ],
        form: [
            {path: "code"},
            {path: "name", type: "textarea"},
            {path: "maturityControls", type: "tags", display: "name", translateName: true},
            {
                path: "axes",
                display: "fullName",
                fieldPath: ['id', 'axisType', 'fullName'],
                filters: ['excludeSelectedTypes'],
                subscriptions: {
                    onChange: (newValue, oldValue, { store }) => {
                        store.dispatch(
                            generateFetchFieldListAction(
                                'm-AU-controlType.ControlType_axes',
                                store.getState,
                                { data: { axesTypes: newValue || [] } }
                            )
                        )
                    }
                },
                validations: [
                    function(formValues) {
                        return function validation(value, values) {
                            const currentTypes = (value || []).map(type => type.axisType.code)
                            const hasDuplicates = _.uniq(currentTypes).length !== currentTypes.length
                            return hasDuplicates ? 'oneValuePerTypeError' : undefined
                        }
                    }
                ]
            },
            {
                path: "stakeHolders",
                fieldPath: ['id', 'stakeholderType', 'fullName'],
                display: "fullName",
                filters: ['excludeSelectedTypes'],
                subscriptions: {
                    onChange: (newValue, oldValue, { store }) => {
                        store.dispatch(
                            generateFetchFieldListAction(
                                'm-AU-controlType.ControlType_stakeHolders',
                                store.getState,
                                { data: { stakeHolders: newValue || [] } }
                            )
                        )
                    }
                },
                validations: [
                    function(formValues) {
                        return function validation(value, values) {
                            const currentTypes = (value || []).map(type => type.stakeholderType.code)
                            const hasDuplicates = _.uniq(currentTypes).length !== currentTypes.length
                            return hasDuplicates ? 'oneValuePerTypeError' : undefined
                        }
                    }
                ]
            },
        ]
    }
}
